import { render, staticRenderFns } from "./NotificationApiToOdoo.vue?vue&type=template&id=5d774dcd&scoped=true&"
import script from "./NotificationApiToOdoo.vue?vue&type=script&lang=js&"
export * from "./NotificationApiToOdoo.vue?vue&type=script&lang=js&"
import style0 from "./NotificationApiToOdoo.vue?vue&type=style&index=0&id=5d774dcd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d774dcd",
  null
  
)

export default component.exports